import React from 'react';
import { Flex } from 'antd';
import ShipmentCommentBox from '../ShipmentCommentBox';
import { CustomButton } from '../../../components';

interface ShipmentAlertCommentBoxProps {
  onAlertTextareaChange: (val: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleToggleAlertInput: () => void;
  onSubmitAlertComment: () => void;
}

const ShipmentAlertCommentBox: React.FC<ShipmentAlertCommentBoxProps> = ({
  onAlertTextareaChange,
  handleToggleAlertInput,
  onSubmitAlertComment,
}) => {
  return (
    <>
      <div style={{ marginTop: '-18px' }}>
        <>
          <ShipmentCommentBox
            onTextareaChange={onAlertTextareaChange}
            placeholder='Add comment (optional)'
          />
          <div style={{ marginBottom: '18px' }}>
            <Flex gap={16}>
              <CustomButton
                text={'Cancel'}
                width='70px'
                height='36px'
                fontSize='12px'
                fontWeight='600'
                lineHeight='16px'
                borderRadius='8px'
                bgColor='var(--light-gray)'
                color='var(--text-primary)'
                boxShadow='none'
                onClick={handleToggleAlertInput}
                iconPosition='left'
                gap={8}
              />
              <CustomButton
                text={'Submit comment'}
                width='147px'
                height='36px'
                fontSize='12px'
                fontWeight='600'
                lineHeight='16px'
                borderRadius='8px'
                bgColor='#000'
                color='#fff'
                boxShadow='none'
                onClick={() => onSubmitAlertComment()}
                iconPosition='left'
                gap={8}
              />
            </Flex>
          </div>
        </>
      </div>
    </>
  );
};

export default ShipmentAlertCommentBox;
